import script from "./TabFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFilter.vue?vue&type=script&setup=true&lang=js"

import "./TabFilter.vue?vue&type=style&index=0&id=526b07ca&lang=scss"

const __exports__ = script;

export default __exports__